module.exports = __webpack_public_path__ + "static/OnLogic-12fb2ace98de94d3b24c8c371dbce53b.png";